<div class="container" *ngIf="finishedLoadingUsers">
    <div class="row">
        <div class=" col-lg-8">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Synchronisation</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row">
                        <div class="col-sm-5">
                            <h5> Datensatz Kundenregistrierung</h5>
                            <div class="row" [formGroup]="accountForm">

                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Kundenummer:</mat-label>
                                        <input matInput type="text" formControlName="customerNumber">

                                    </mat-form-field>
                                </div>

                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Anrede:</mat-label>
                                        <mat-select formControlName="gender">
                                            <mat-option *ngFor="let sortOption of genderOptions"
                                                [value]="sortOption.value">
                                                {{sortOption.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="accountForm.get('gender').hasError('required')">
                                            Anrede <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Titel:</mat-label>
                                        <input matInput type="text" formControlName="title">
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Vorname:</mat-label>
                                        <input matInput type="text" formControlName="firstName">
                                        <mat-error *ngIf="accountForm.get('firstName').hasError('required')">
                                            Vorname <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Nachname:</mat-label>
                                        <input matInput type="text" formControlName="lastName">
                                        <mat-error *ngIf="accountForm.get('lastName').hasError('required')">
                                            Nachname <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Geburtstag:</mat-label>
                                        <input matInput type="date" formControlName="birthday">
                                        <mat-error *ngIf="accountForm.get('birthday').hasError('required')">
                                            Geburtstag <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row" [formGroup]="addressForm">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Straße + Hausnummer:</mat-label>
                                        <input matInput type="text" formControlName="street">
                                        <mat-error *ngIf="addressForm.get('street').hasError('required')">
                                            Straße + Hausnummer <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>PLZ:</mat-label>
                                        <input matInput type="text" formControlName="postcode">
                                        <mat-error *ngIf="addressForm.get('postcode').hasError('required')">
                                            PLZ <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Ort:</mat-label>
                                        <input matInput type="text" formControlName="city">
                                        <mat-error *ngIf="addressForm.get('city').hasError('required')">
                                            Ort <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>



                        </div>
                        <div class="col-sm-2">
                            <h5> Übernehmen</h5>
                            <div class="btnWrapper">
                                <button mat-button mat-raised-button color="primary" (click)="moveData(1)" [disabled]="disableMove1">
                                    <mat-icon>keyboard_arrow_left</mat-icon>
                                </button>
                                <button mat-button mat-raised-button color="primary" (click)="moveData(2)" [disabled]="disableMove2">
                                    <mat-icon>keyboard_arrow_left</mat-icon>
                                </button>
                                <button mat-button mat-raised-button color="primary" (click)="moveData(3)" [disabled]="disableMove3">
                                    <mat-icon>keyboard_arrow_left</mat-icon>
                                </button>
                                <button mat-button mat-raised-button color="primary" (click)="moveData(4)" [disabled]="disableMove4">
                                    <mat-icon>keyboard_arrow_left</mat-icon>
                                </button>
                                <button mat-button mat-raised-button color="primary" (click)="moveData(5)" [disabled]="disableMove5">
                                    <mat-icon>keyboard_arrow_left</mat-icon>
                                </button>
                                <button mat-button mat-raised-button color="primary" (click)="moveData(6)" [disabled]="disableMove6">
                                    <mat-icon>keyboard_arrow_left</mat-icon>
                                </button>
                                <button mat-button mat-raised-button color="primary" (click)="moveData(7)" [disabled]="disableMove7">
                                    <mat-icon>keyboard_arrow_left</mat-icon>
                                </button>
                                <button mat-button mat-raised-button color="primary" (click)="moveData(8)" [disabled]="disableMove8">
                                    <mat-icon>keyboard_arrow_left</mat-icon>
                                </button>
                            </div>
                        </div>

                        <div class="col-sm-5">
                            <h5> Datensatz ERP-System</h5>

                            <div class="row" [formGroup]="accountFormERP">

                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Kundenummer:</mat-label>
                                        <input matInput type="text" formControlName="customerNumber">

                                    </mat-form-field>
                                </div>

                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Anrede:</mat-label>
                                        <mat-select formControlName="gender">
                                            <mat-option *ngFor="let sortOption of genderOptions"
                                                [value]="sortOption.value">
                                                {{sortOption.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="accountForm.get('gender').hasError('required')">
                                            Anrede <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Titel:</mat-label>
                                        <input matInput type="text" formControlName="title">
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Vorname:</mat-label>
                                        <input matInput type="text" formControlName="firstName">
                                        <mat-error *ngIf="accountForm.get('firstName').hasError('required')">
                                            Vorname <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Nachname:</mat-label>
                                        <input matInput type="text" formControlName="lastName">
                                        <mat-error *ngIf="accountForm.get('lastName').hasError('required')">
                                            Nachname <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Geburtstag:</mat-label>
                                        <input matInput type="date" formControlName="birthday">
                                        <mat-error *ngIf="accountForm.get('birthday').hasError('required')">
                                            Geburtstag <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row" [formGroup]="addressFormERP">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Straße + Hausnummer:</mat-label>
                                        <input matInput type="text" formControlName="street">
                                        <mat-error *ngIf="addressForm.get('street').hasError('required')">
                                            Straße + Hausnummer <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>PLZ:</mat-label>
                                        <input matInput type="text" formControlName="postcode">
                                        <mat-error *ngIf="addressForm.get('postcode').hasError('required')">
                                            PLZ <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Ort:</mat-label>
                                        <input matInput type="text" formControlName="city">
                                        <mat-error *ngIf="addressForm.get('city').hasError('required')">
                                            Ort <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-5">

                            <div class="row marginTop2Rem">
                                <div class="col-sm-12">
                                    <table>
                                        <thead>
                                            <td>
                                                Vertragsnr.
                                            </td>
                                            <td>
                                                Zählertyp
                                            </td>
                                            <td>
                                                Status
                                            </td>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let contract of contracs">
                                                <td>
                                                    {{contract.number}}
                                                </td>
                                                <td>
                                                    {{contract.contractType | translateState}}
                                                </td>

                                                <td>
                                                    {{contract.contractState | translateState}}
                                                </td>

                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2"></div>
                        <div class="col-sm-5">
                            <div class="row marginTop2Rem">
                                <div class="col-sm-12">
                                    <table>
                                        <thead>
                                            <td>
                                                Vertragsnr.
                                            </td>
                                            <td>
                                                Zählertyp
                                            </td>
                                            <td>
                                                Status
                                            </td>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let contract of contracsERP">
                                                <td>
                                                    {{contract.number}}
                                                </td>
                                                <td>
                                                    {{contract.contractType | translateState}}
                                                </td>

                                                <td>
                                                    {{contract.contractState | translateState}}
                                                </td>

                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="this.contracsERP.length != 0">
                        <div class="col-sm-5">
                        </div>
                        <div class="col-sm-7">
                            <mat-hint style="float: right;">
                                Die Verträge werden beim Speichern synchronisiert
                            </mat-hint>
                        </div>

                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="editUser()">Änderungen
                        speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>

        <div class=" col-lg-4">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title> Kunden finden in ERP</mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="searchForm">
                    <mat-form-field class="full-width" appearance="fill">
                        <mat-label>Suche</mat-label>
                        <input type="text" matInput formControlName="searchTerm" placeholder="suchen.."
                            (keydown)="onKeydown($event)">
                    </mat-form-field>

                    <button mat-button class="marginBottom2Rem" mat-raised-button color="accent"
                        (click)="filterCustomers()">
                        Anwenden
                    </button>

                    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                        <ng-container matColumnDef="menu" class="mat-column">
                            <th mat-header-cell *matHeaderCellDef>
                                Übernehmen
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-icon-button color="primary" style="margin: 0 auto !important;"
                                    (click)="patchData(element)">
                                    <mat-icon>keyboard_arrow_left</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="customerNumber" class="mat-column">
                            <th mat-header-cell *matHeaderCellDef>
                                Kundennr
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.customer?.customerNumber}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="user" class="mat-column">
                            <th mat-header-cell *matHeaderCellDef>
                                Kunde
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.customer.person?.displayName}}
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                    </table>
                    <span *ngIf="dataSource?.data.length === 0" class="emptyTableState">Keine passenden Einträge
                        gefunden</span>


                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<div class="container" *ngIf="!finishedLoadingUsers">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>